import { useMemo } from 'react';

import { getNewMarginBuyUrl, getSymbolBuySellUrl } from '../formatter';
import { isJpeq, isUseq } from '../symbol';
import { getTaBuyUrl, getTaDetailUrl, getTaSellUrl } from '../taSsoUrlBuilder';

export function buildTradingUrls(symbol, assetClass, user = {}) {
  const safeUser = user || {};
  const dm = safeUser.dm;
  const attrSrcKey = safeUser.attrSrcKey;
  const isUseqSymbol = isUseq(assetClass);
  const isJpeqSymbol = isJpeq(assetClass);

  return {
    cashBuy: isUseqSymbol
      ? dm
        ? getTaBuyUrl(dm, symbol)
        : null
      : getSymbolBuySellUrl(assetClass, symbol, safeUser, 'buy'),
    cashSell: isUseqSymbol
      ? dm
        ? getTaSellUrl(dm)
        : null
      : getSymbolBuySellUrl(assetClass, symbol, safeUser, 'sell'),
    margin: isJpeqSymbol
      ? getNewMarginBuyUrl(dm, attrSrcKey, symbol)
      : isUseqSymbol && dm
        ? getTaDetailUrl(dm, symbol)
        : null,
    details: isUseqSymbol && dm ? getTaDetailUrl(dm, symbol) : null
  };
}

export function useTradingUrls(symbol, assetClass, user) {
  return useMemo(
    () => buildTradingUrls(symbol, assetClass, user),
    [assetClass, symbol, user]
  );
}